import { createContext, type JSX, type ReactNode, useContext, useMemo } from 'react';
import { type Brand, brandConfig, currentBrand, isTecalor } from '@common/brand/brandConfig';

interface BrandContextType {
  brand: Brand;
  isTecalor: boolean;
  brandConfig: typeof brandConfig;
}

const BrandContext = createContext<BrandContextType | undefined>(undefined);

const errorMessage = 'useBrand must be used within <BrandProvider>';

export function BrandProvider({ children }: Readonly<{ children: ReactNode; }>): JSX.Element {
  const value = useMemo(
    () => ({ brand: currentBrand, isTecalor, brandConfig }),
    [],
  );

  return (
    <BrandContext.Provider value={value}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand(): BrandContextType {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error(errorMessage);
  }
  return context;
}
